const style = () => ({
    display: "flex",
    flexDirection: "column",
    margin: 0,
    padding: 0,
});

export default style;
